import { type CoverageProduct } from './marketableProduct';

export enum DiscountType {
  DISCRETIONARY_DISCOUNT = 'DISCRETIONARY_DISCOUNT',
  WAIT_PERIOD_DISCOUNT = 'WAIT_PERIOD_DISCOUNT',
}

export interface Premium {
  sumInsured: number;
  annualNetPremium: PremiumAmount;
  annualGrossPremium: PremiumAmount;
  monthlyNetPremium: PremiumAmount;
  monthlyGrossPremium: PremiumAmount;
  discounts: Discount[];
  suggestedSumInsured: PremiumSuggestedSumInsured;
  deductibleDays?: number | null;
}

interface PremiumSuggestedSumInsured {
  isSuggested: boolean;
  exceedsMax: boolean;
}

export interface PremiumAmount {
  amount: number;
  amountInCents: number;
}

export interface Discount {
  name: DiscountType;
  monthlyValue: number;
  annualValue: number;
  percentage?: number;
}

export interface CoveragePremium {
  coverageProduct: CoverageProduct;
  premiums: Premium[];
}

export interface PremiumPerInstallment {
  installmentAmount: number;
  netPremiumPerInstallment: PremiumAmount;
  period: number;
}

export type CoveragePremiums = Record<CoverageProduct, Premium | undefined>;
